// 预览播放器
import Render from './Render'
import YUVDeflateDecoder from './YUVDeflateDecoder'
import MC from './MediaCenter';
import MCMsg from './MediaCenterMsg';
import utils from '../../utils';

const PreviewPlayer = function (opts) {
    opts = opts || {};
    if (opts.ctor === false) {
        return;
    }
    this._ctor(opts);
};

const pt = PreviewPlayer.prototype;

utils.EventExtend.install(pt);

pt._ctor = function(opts) {
    const that = this;
    this.dom = opts.dom;
    this.camera = opts.camera || {};
    this.width = opts.width || this.dom.offsetWidth;
    this.height = opts.height || this.dom.offsetHeight;
    this.render = new Render({
        size: {
            width: this.width,
            height: this.height
        }
    });

    let initDom = opts.initDom || this.initDom;

    initDom.apply(this, [opts]);

    this.isStop = false;

    if (this.camera && this.camera.cameraName) {
        this.setTitle(this.camera.cameraName);
    }

    this.decoder = new YUVDeflateDecoder({
        rgb: this.render.renderType == 'rgb'
    });
    this.decoder.onError = function(e) {
        console.error(e);
        that.stop();
    };
    this.decoder.onDecoded = function(buffer, width, height, infos) {
        if (infos.frameType != 6) {
            return;
        }
        if (width > 0 && height > 0) {
            try {
                that.render.draw(buffer, width, height, infos);
            }
            catch(e) {
                console.error(e);
                that.stop();
                return;
            }

            if (that.lastTimestamp && infos.timestamp - that.lastTimestamp >= 30000) {
                if (!that.$reconnecting) {
                    console.debug('超时，重连媒体中心...', infos.timestamp - that.lastTimestamp);
                    //时间戳过长，重连
                    that.stop({
                        reconnecting: true
                    });
                }
            }
            that.lastTimestamp = infos.timestamp;
        }
        else {
            console.error("Invalid 'width' and 'height'");
            that.stop();
            return;
        }
    };
};

pt.initDom = function(/*opts*/) {
    const that = this;

    this.dom.insertBefore(this.render.canvas, this.dom.firstElementChild);
    this.dom.className = (this.dom.className || '') + ' zj-player zj-player-preview';
    
    let titlebar = document.createElement('DIV');
    titlebar.className = 'zj-player-titlebar';
    this.dom.appendChild(titlebar);
    this.titlebar = titlebar;

    let statusbar = document.createElement('DIV');
    statusbar.className = 'zj-player-statusbar';
    this.dom.appendChild(statusbar);
    this.statusbar = statusbar;

    let msgbar = document.createElement('DIV');
    msgbar.className = 'zj-player-statusbar-msgbar';
    this.statusbar.appendChild(msgbar);
    this.msgbar = msgbar;

    let toolbar = document.createElement('DIV');
    toolbar.className = 'zj-player-statusbar-toolbar';
    this.statusbar.appendChild(toolbar);
    this.toolbar = toolbar;
    
    let buttonbar = document.createElement('DIV');
    buttonbar.className = 'zj-player-buttonbar';
    this.dom.appendChild(buttonbar);
    this.buttonbar = buttonbar;
    buttonbar.innerHTML = ['<svg version="1.1" class="play-button" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">',
'<g>',
'   <path d="M256,0C114.833,0,0,114.844,0,256s114.833,256,256,256s256-114.844,256-256S397.167,0,256,0z M357.771,264.969',
'       l-149.333,96c-1.75,1.135-3.771,1.698-5.771,1.698c-1.75,0-3.521-0.438-5.104-1.302C194.125,359.49,192,355.906,192,352V160',
'       c0-3.906,2.125-7.49,5.563-9.365c3.375-1.854,7.604-1.74,10.875,0.396l149.333,96c3.042,1.958,4.896,5.344,4.896,8.969',
'       S360.813,263.01,357.771,264.969z"/>',
'</g>',
'</svg>',
'<svg version="1.1" class="stop-button" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve">',
'<g>',
'<path d="M256,0C114.833,0,0,114.844,0,256s114.833,256,256,256s256-114.844,256-256S397.167,0,256,0z M362.667,352',
'   c0,5.896-4.771,10.667-10.667,10.667H160c-5.896,0-10.667-4.771-10.667-10.667V160c0-5.896,4.771-10.667,10.667-10.667h192',
'   c5.896,0,10.667,4.771,10.667,10.667V352z"/>',
'</g>',
'</svg>'].join('')

    let btn = buttonbar.querySelector('.play-button');
    if (btn) {
        btn.onclick = function() {
            that.play(that.camera);
        };
    }

    btn = buttonbar.querySelector('.stop-button');
    if (btn) {
        btn.onclick = function() {
            that.stop();
            that.$emit('clickStopButton', {
                name: 'clickStopButton',
                data: undefined
            });
        };
    }
};

pt.addClass = function(name) {
    let x = this.dom.className.split(' ');
    let arr = [];
    let exists = false;
    for(let i = 0; i < x.length; i++) {
        if (!x[i]) { continue; }
        if (x[i] == name) {
            exists = true;
            arr.push(x[i]);
        }
        else {
            arr.push(x[i]);
        }
    }
    if (!exists) {
        arr.push(name);
    }
    this.dom.className = arr.join(' ');
    return this;
};

pt.removeClass = function(name) {
    let x = this.dom.className.split(' ');
    let arr = [];
    for(let i = 0; i < x.length; i++) {
        if (!x[i]) { continue; }
        if (x[i] != name) {
            arr.push(x[i]);
        }
    }
    this.dom.className = arr.join(' ');
    return this;
};

pt.setTitle = function(title) {
    if (this.titlebar) {
        this.titlebar.innerHTML = title ? '<span>' + title + '</span>' : '';
    }
};

pt.setStatus = function(text, hold) {
    const msgbar = this.msgbar;
    if (!msgbar) {
        return;
    }
    msgbar.innerHTML = text ? '<span>' + text + '</span>' : '';
    if (text) {
        msgbar.style.display = 'block';
        clearTimeout(this.msgbarTimer);
        this.msgbarTimer = null;
        if (!hold) {
            const that = this;
            this.msgbarTimer = setTimeout(function(){
                that.msgbarTimer = null;
                msgbar.style.display = 'none';
            }, 5000);
        }
    }
    else {
        if (!this.msgbarTimer) {
            msgbar.style.display = 'none';
        }
    }
};

pt.setCameraId = function(id) {
    this.camera = this.camera || {};
    this.camera.cameraId = id;
};

pt.isPlaying = function() {
    return !this.isStop;
};

pt.play = function(camera) {
    this.camera = camera = camera || this.camera || {};
    if (!this.camera || !this.camera.cameraId) {
        this.stop();
        return;
    }
    this.removeClass('stopped');
    this.addClass('playing');
    this.isStop = false;
    if (camera && camera.cameraName) {
        this.setTitle(camera.cameraName);
    }
    this.lastTimestamp = 0;
    if (this.$connected) {
        this.stop({
            reconnecting: true
        });
    }
    else if (!this.$connecting) {
        this.connect();
    }
};

pt.stop = function(opts) {
    opts = opts || {};
    this.removeClass('playing');
    this.addClass('stopped');
    this.setStatus(opts.stopMsg || '停止中...');
    this.$reconnecting = opts.reconnecting || false;
    this.isStop = true;
    this.stopMsg = opts.stopMsg || '';
    if (this.$connected) {
        this.$mc.sendStop();
        setTimeout((function(mc) {
            return function() {
                if (mc.$connected) {
                    mc.close();
                }
            };
        })(this.$mc), 1000);
    }
    else {
        this.setStatus('');
    }
};

pt.destroy = function() {
    this.stop();
    if (this.decoder) {
        this.decoder.destroy();
        this.decoder = null;
    }
    if (this.render) {
        this.dom.removeChild(this.render.canvas);
        this.render.destroy();
        this.render = null;
    }
};

pt.resize = function(opts) {
    opts = opts || {};
    this.width = opts.width || this.dom.offsetWidth;
    this.height = opts.height || this.dom.offsetHeight;
    if (this.$connected) {
        this.$mc.sendResize({
            width: this.width,
            height: this.height
        });
    }
};

//发送播放指令
pt.sendPlayCmd = function(camera) {
    this.$mc.sendPreview(utils.extend({
        width: this.width || this.dom.offsetWidth,
        height: this.height || this.dom.offsetWidth
    }, camera || this.camera));
};

pt.sendCtrlCmd = function(data) {
    this.$mc.sendCmd(MCMsg.CTRL, data);
};

// 收到消息
pt.onMsg = function(e) {
    const msg = e.data;
    if (msg.isData()) {
        if (msg.msgCode == MCMsg.YUV) {
            if (this.$firstData) {
                this.$firstData = false;
                this.setStatus('');
            }
            try {
                if (this.$connected) {
                    this.decoder.write(msg.msgData);
                }
            }
            catch(e) {
                console.error(e);
                this.stop();
            }
        }
        else if (msg.msgCode == MCMsg.CAMERA_INFO) {
            let s = utils.utf8ByteArrayToString(msg.msgData || []);
            let info = JSON.parse(s);
            this.cameraInfo = info;
            //console.log(info);
            this.setTitle(info.cameraName);
            //setTimeout(function() {
            //    that.setStatus('');
            //}, 1000);
        }
        else if (msg.msgCode == MCMsg.STREAM_URL) {
            let s = utils.utf8ByteArrayToString(msg.msgData || []);
            let info = JSON.parse(s);
            this.streamUrl = info;
            console.debug(this.cameraInfo.cameraName + '的取流地址: ', info);
        }
        else {
            // drop data
        }
    }
    else {
        if (msg.isError() && msg.msgCode != 0) {
            var errmsg = utils.utf8ByteArrayToString(msg.msgData) || '预览失败';
            console.error(errmsg);
            var index = errmsg.indexOf('。');
            if (index != -1) {
                errmsg = errmsg.substr(0, index);
            }
            else {
                index = errmsg.indexOf('\n');
                if (index != -1) {
                    errmsg = errmsg.substr(0, index);
                }
            }
            this.stop({
                stopMsg: '<span class="zj-player-errmsg">' + errmsg + '</span>'
            });
        }
        this.$emit('msg', {
            name: 'msg',
            data: msg
        });
    }
};

pt.onConnected = function() {
    if (this.camera) {
        this.setStatus('取流中...', true);
        this.sendPlayCmd();
    }
    else {
        this.stop();
    }
};

// 连接媒体中心
pt.connect = function() {
    const that = this;
    this.$connecting = true;
    this.$connected = false;

    that.setStatus('连接中...', true);
    that.$emit('connecting', {
        name: 'connecting'
    });
    console.debug('PreviewPlayer - connecting');

    let mc = this.$mc = new MC();

    this.$firstData = true;

    mc.on('connected', function (e) {
        that.$connecting = false;
        that.$connected = true;
        that.$emit('connected', {
            name: 'connected',
            data: e.data
        });
        console.debug('PreviewPlayer - connected');
        if (!that.isStop) {
            that.onConnected();
        }
        else {
            that.stop();
        }
    });

    mc.on('closed', function (e) {
        that.$connecting = false;
        that.$connected = false;
        that.$mc = null;
        that.lastTimestamp = 0;
        that.setStatus(that.stopMsg || '', !!that.stopMsg);
        that.$emit('stopped', {
            name: 'stopped',
            data: e.data
        });
        console.debug('PreviewPlayer - stopped');
        if (that.$reconnecting || !that.isStop) {
            that.$reconnecting = false;
            that.play(that.camera);
        }
    });

    mc.on('error', function (e) {
        console.error('error', e);
        that.$emit('error', {
            name: 'error',
            error: e.error
        });
        that.stop({
            stopMsg: '<span class="zj-player-errmsg">' + e.error + '</span>'
        });
        that.setStatus('连接媒体中心失败');
    });

    mc.on('msg', function (e) {
        that.onMsg(e);
    });

    mc.connect();
};

export default PreviewPlayer;
